/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class Uploads extends NoboxEntityGrid<LognotesRow, any> {
        protected getColumnsKey() { return UploadsColumns.columnsKey; }
        protected getDialogType() { return LognotesDialog; }
        protected getIdProperty() { return LognotesRow.idProperty; }
        protected getInsertPermission() { return LognotesRow.insertPermission; }
        protected getLocalTextPrefix() { return LognotesRow.localTextPrefix; }
        protected getService() { return LognotesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }
        protected getButtons(): Serenity.ToolButton[] {
            return [];
        }
        protected getViewOptions() {
            let opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            opt.url = Q.resolveUrl('~/Services/' + this.getService() + '/ListAgentConversation')
            return opt;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Administration.UserListRequest;
            request.IncludeColumns = ["TenantId", "DisplayName", "LastLogin", "JmlConversation"];
            //request.ColumnSelection = 1;
            return true;
        }
    }
}